<template>
  <div class="amap-container">
    <div ref="mapRef" style="height: 100%" />
    <img
      class="refresh-img"
      src="@/assets/location/refresh.png"
      @click="handleRefresh"
    />
  </div>
</template>

<script>
export default {
  name: "Amap",
  props: {
    markerList: {
      type: Array,
      default: () => [],
    },
    zoom: {
      type: Number,
      default: 12,
    },
    center: {
      type: Array,
      default: () => [116.397428, 39.90923],
    },
  },
  data() {
    return {
      map: null,
      markers: [],
    };
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
  watch: {
    markerList: {
      handler(newVal) {
        if (this.map) {
          if (newVal && newVal.length > 0) {
            this.addMarkers();
          } else {
            this.resetMap();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    handleRefresh(callback) {
      this.$emit("refresh", () => {
        this.initMap();
      });
    },
    resetMap() {
      if (this.map) {
        this.map.clearMap();
        this.map.setCenter(this.center);
        this.map.setZoom(this.zoom);
      }
    },
    initMap() {
      this.map = new AMap.Map(this.$refs.mapRef, {
        zoom: this.zoom,
        resizeEnable: true,
        mapStyle: "amap://styles/fa472cf76b0c14ed30811bbeb3b910cc",
        center: this.center,
      });

      this.map.on("click", () => {
        this.map.clearInfoWindow();
      });

      this.addMarkers();
    },
    addMarkers() {
      if (!this.map || !this.markerList || this.markerList.length === 0) return;

      this.map.clearMap();
      this.markers = [];

      this.markerList.forEach((item) => {
        const lng = parseFloat(item.lng);
        const lat = parseFloat(item.lat);
        if (isNaN(lng) || isNaN(lat) || lng <= 0 || lat <= 0) return;

        let markerOptions = {
          position: [lng, lat],
          title: item.title || "",
          offset: new AMap.Pixel(-52, -27),
        };

        if (item.isMinView && item.icon) {
          markerOptions.icon = new AMap.Icon({
            size: new AMap.Size(32, 32),
            image: item.icon,
            imageSize: new AMap.Size(32, 32),
          });
        } else {
          const markerContent = document.createElement("div");
          markerContent.className = "custom-marker";

          const countDiv = document.createElement("div");
          countDiv.className = "marker-count";
          countDiv.textContent = item.count || 0;

          const provinceDiv = document.createElement("div");
          provinceDiv.className = "marker-province";
          provinceDiv.textContent = item.fullName || "";

          markerContent.appendChild(countDiv);
          markerContent.appendChild(provinceDiv);
          markerOptions.content = markerContent;
        }

        const marker = new AMap.Marker(markerOptions);

        marker.on("click", () => {
          if (item.isMinView) {
            setTimeout(() => {
              this.map.setZoomAndCenter(20, marker.getPosition());
            }, 100);
            this.showInfoWindow(marker.getPosition(), item);
          } else {
            this.$emit("marker-click", item);
          }
        });

        this.markers.push(marker);
        this.map.add(marker);
      });

      if (this.markers.length > 0) {
        this.map.setFitView(this.markers);
      }
    },
    showInfoWindow(position, item) {
      let typesHtml = "";
      if (item.enterpriseTypes && item.enterpriseTypes.length > 0) {
        const typeClassMap = {
          药品生产: "ypsc",
          药品批发: "yppf",
          连锁总部: "lszb",
          连锁门店: "lsmd",
          医疗机构: "yljg",
          单体门店: "dtmd",
        };
        item.enterpriseTypes.forEach((v, i) => {
          const tagClass = typeClassMap[v] || "";
          typesHtml += `<div class="map-info-tag ${tagClass}">${v}</div>`;
        });
      }
      const infoWindow = new AMap.InfoWindow({
        isCustom: true,
        content: `<div class="map-info-window">
          <div class="map-info-title">${item.enterpriseName || ""}</div>
          <div class="map-info-tag-box">
              ${typesHtml}
            </div>
          <div class="map-info-content">${item.enterpriseLocation || ""}</div>
        </div>`,
        offset: new AMap.Pixel(0, -40),
      });
      infoWindow.open(this.map, position);
    },
    showInfoWindowAndClear(position, item) {
      if (this.map) {
        this.map.clearMap();

        const marker = new AMap.Marker({
          position: position,
          title: "",
          offset: new AMap.Pixel(-15, -30),
          icon: new AMap.Icon({
            size: new AMap.Size(32, 32),
            image: item.icon,
            imageSize: new AMap.Size(32, 32),
          }),
        });

        this.map.add(marker);
      }

      setTimeout(() => {
        this.map && this.map.setZoomAndCenter(20, position);
      }, 100);

      this.showInfoWindow(position, item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
